import React, { useState, useEffect } from "react";

// Style sheet
import "bootstrap/dist/css/bootstrap.min.css";
import "../scss/feltTremorAlert.scss";

// Bootstrap Components
import Container from "react-bootstrap/Container";

// debug json
import data_debug from "../../../../resources/earthquake.php.json";
// END

import { getFeltTermorMessage } from "../../../service/apiHKOWeatherInfoService";

// Type of information
type alertObject = {
  id: number;
  info: string;
};
// END

function KeyFatch(keyFatchSource: Object): Array<alertObject> {
  let alertInformationArray: Array<alertObject> = new Array<alertObject>();

  const keys = Object.keys(keyFatchSource) as Array<string>;
  if (keys.length === 0) {
    return alertInformationArray;
  }

  let key = "details";
  let content: any = keyFatchSource[key as keyof typeof keyFatchSource];
  let contentIDAlert: number = 0;

  content.forEach((contentItem: string) => {
    if (
      contentItem.indexOf("震中位置圖") < 0 &&
      contentItem.indexOf("有關修訂麥加利地震烈度表的詳細解釋") < 0
    ) {
      let alertInformation: alertObject = {
        id: contentIDAlert,
        info: contentItem,
      };

      alertInformationArray.push(alertInformation);
    }
  });

  return alertInformationArray;
}

function FeltTremorAlert() {
  const [alertList, setAlertList] = useState<Array<alertObject>>([]);

  async function getFetchFeltTremorAlertInfomation() {
    await getFeltTermorMessage()
      .then((response) => {
        return response.data;
      })
      .then((data) => {
        setAlertList(KeyFatch(data));
      });
  }

  useEffect(() => {
    getFetchFeltTremorAlertInfomation();
  }, []);

  if (alertList?.length !== 0 && alertList !== null) {
    return (
      <Container>
        <div id="feltTremorAlertBox">
          <div id="feltTremorAlertBox_Title">有感地震報告(天文台)</div>
          <div>
            {alertList.map((item) => (
              <div
                key={"feltTremor_" + item.id}
                className="feltTremorAlertBox_Content"
              >
                {item.info}
              </div>
            ))}
          </div>
        </div>
      </Container>
    );
  } else {
    return null;
  }
}

export default FeltTremorAlert;
